<template>
    <div v-if="story != null && allImages.length > 1">
        <ion-list>
            <ion-item button v-for="(item, index) in allImages" :key="'exploreKey-' + index"
                v-on:click="goToStory(item.id)">
                <ion-thumbnail style="top:0; position:relative;" slot="start">
                    <img :id="'image_' + index" :src="path + '/piks/' + item.pik_name" />
                    <div class="video-play" v-show="isVideo(item.type)">
                        <ion-icon class="video-play-icon-sm" :icon="playCircle"></ion-icon>
                    </div>
                </ion-thumbnail>
                <ion-label class="ion-text-wrap">
                    <h2 style="max-height:76px;"><span v-html="item.description"></span></h2>
                    <p style="font-size:0.8em;">{{ getUploadDate(item.date_time, this.$root.$i18n.locale) }}</p>
                </ion-label>
            </ion-item>
        </ion-list>
        <ion-infinite-scroll @ionInfinite="loadMorePosts($event)" id="infinite-scroll">
            <ion-infinite-scroll-content loading-spinner="bubbles" :loading-text="$t('loadmessage.loadingexplore')">
            </ion-infinite-scroll-content>
        </ion-infinite-scroll>
    </div>
</template>

<script>
import { IonList, IonItem, IonIcon, IonThumbnail, IonLabel, loadingController, IonInfiniteScroll, IonInfiniteScrollContent } from '@ionic/vue';
import { playCircle, arrowBackCircle } from 'ionicons/icons';
import getEnv from '@/utils/env'
import { getUploadDate } from '@/composables/date';

export default {
    name: 'ShowMoreContainer',
    props: {
        story: { Object, default: null },
        imageSelected: { Number, default: 0 },
        isModal: { Boolean, default: false }
    },
    emits: ['update:imageSelected'],
    components: {
        IonList, IonItem, IonIcon, IonThumbnail, IonInfiniteScroll, IonInfiniteScrollContent, IonLabel
    },
    setup() {
        return { playCircle, arrowBackCircle, getUploadDate }
    },
    data() {
        return {
            loadingIndicator: '',
            path: getEnv('AWS_URL') + getEnv('PHOTO_BUCKET'),
            allImages: [],
            nextPage: false
        }
    },
    async mounted() {
        for (let x in this.story.allimages) {
            this.allImages.push(this.story.allimages[x]);
        }
        this.allImages.reverse();
        //this.getExplore();
    },
    methods: {
        async goToStory(id) {
            if (this.isModal || this.nextPage) {
                this.$emit('update:imageSelected', id);
                this.$router.push({name: 'story', params: { imageid: id } });
            }else{
                this.$emit('update:imageSelected', id);
            }
        },
        async loadMorePosts(event) {
            let totalImagesLoaded = this.allImages.length;
            let totalImages = this.story.totalvids + this.story.totalpiks;
            //console.log(totalImages, 'total images');
            //console.log(totalImagesLoaded, 'total images loaded');
            if (totalImages <= totalImagesLoaded) {
                event.target.complete();
            } else {
                let finished = await this.pagingOptions(totalImagesLoaded, totalImages, 'back');
                if (finished) {
                    event.target.complete();
                    this.nextPage = true;
                    //console.log(finished, 'finished');
                }
            }
        },
        async pagingOptions(totalImagesLoaded, totalImages, direction) {
            var newPage = 0;
            var newTotal = 0;
            let currentIndex = this.allImages[totalImagesLoaded - 1].current_index;
            //console.log(currentIndex, 'current index');
            if (direction == 'back') {
                newPage = currentIndex - 10;
                if (newPage < 0) {
                    newPage = 0;
                }
                newTotal = 10;
                if (currentIndex < 10) {
                    newTotal = currentIndex;
                }
            }

            //console.log("get next page: " + "pikstream/pagev2?totalList=" + newTotal + "&currentPage=" + newPage + "&id=" + this.story.piklist_id);
            let response = await this.$store.dispatch("pikstream/pageStory", {
                url: "pikstream/pagev2?totalList=" + newTotal + "&currentPage=" + newPage + "&id=" + this.story.piklist_id,
                streamType: 'postsView'
            });

            if (response) {
                if (response.error != undefined) {
                    console.log('Error: ' + response.error);
                } else {
                    let imageSize = this.allImages.length;
                    let arrayReverse = response.allimages.reverse();
                    for (let x in arrayReverse) {
                        this.allImages[imageSize] = arrayReverse[x];
                        imageSize++;
                    }
                    return direction;
                }
            }
        },
        async presentLoading() {
            this.loadingIndicator = await loadingController
                .create({
                    cssClass: 'loading-class',
                    message: this.$t('loadmessage.updating'),
                });
            await this.loadingIndicator.present();
        },
        isVideo(type) {
            let videoType = false
            if (type != null) {
                if (type == 2) videoType = true;
            }
            return videoType;
        },
        showImage(storyImage) {
            let canShowImage = true;
            if (storyImage != null) {
                if (storyImage.type == 3) {
                    if (storyImage.link_image == '') {
                        canShowImage = false;
                    }
                }
            } else {
                canShowImage = false;
            }
            return canShowImage;
        },
        isSelected(id) {
            let style = '';
            //console.log(this.imageSelected, 'image selected');
            if (id == this.imageSelected) {
                style = ' thumb-selected';
            } else if (id == this.$route.params.imageid && this.imageSelected == 0) {
                style = ' thumb-selected';
            }
            return style;
        },
        showDescription(description) {
            let returnDescription = description;
            if (description.length > 250) {
                var stopSpace = description.indexOf(" ", 250);
                if (stopSpace == -1) {
                    stopSpace = description.length;
                } else {
                    //console.log(stopSpace, 'stop space');
                    //console.log(description, 'description');
                    returnDescription = description.substring(0, stopSpace);
                    returnDescription = returnDescription + "...";
                }
            }
            return returnDescription;
        }
    }
}
</script>

<style scoped>
ion-thumbnail {
    --size: 120px;
    --border-radius: 7px;
}

.explore-grid {
    --ion-grid-padding: 0px;
}

.explore-column {
    --ion-grid-column-padding: 1.0px;
}
</style>
 